export default {
	dealerStructure(state) {
		return state.dealers;
	},
};
